import React from 'react';
import { TrophyIcon, UserIcon, UsersIcon, ArrowRightIcon } from 'lucide-react';
export const Challenges: React.FC = () => {
  return <div className="p-4 md:p-6 md:ml-64 pb-16 md:pb-6" data-id="element-231">
      <div className="mb-6" data-id="element-232">
        <h1 className="text-2xl font-bold text-gray-800" data-id="element-233">Challenges</h1>
        <p className="text-gray-600" data-id="element-234">Neue Gewohnheiten leicht gemacht</p>
      </div>
      {/* Active Challenge */}
      <section className="mb-8" data-id="element-235">
        <div className="flex justify-between items-center mb-4" data-id="element-236">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-237">
            Deine aktive Challenge
          </h2>
          <span className="bg-orange-100 text-orange-600 text-xs px-2 py-1 rounded-full" data-id="element-238">
            Tag 4 von 7
          </span>
        </div>
        <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-239">
          <div className="h-32 bg-orange-200 relative" data-id="element-240">
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-241">
              <div className="text-center" data-id="element-242">
                <TrophyIcon size={32} className="text-orange-600 mx-auto mb-2" data-id="element-243" />
                <h3 className="font-bold text-gray-800" data-id="element-244">
                  7-Tage Kältechallenge
                </h3>
              </div>
            </div>
          </div>
          <div className="p-4" data-id="element-245">
            <div className="flex justify-between items-center mb-3" data-id="element-246">
              <p className="text-gray-600 text-sm" data-id="element-247">Fortschritt</p>
              <p className="text-sm font-medium text-purple-600" data-id="element-248">4/7 Tage</p>
            </div>
            <div className="w-full bg-gray-200 rounded-full h-2 mb-4" data-id="element-249">
              <div className="bg-orange-500 h-2 rounded-full" style={{
              width: '57%'
            }} data-id="element-250"></div>
            </div>
            <div className="flex space-x-2 mb-4" data-id="element-251">
              {[1, 2, 3, 4, 5, 6, 7].map(day => <div key={day} className={`w-8 h-8 rounded-full flex items-center justify-center ${day <= 4 ? 'bg-orange-100 text-orange-600' : 'bg-gray-100 text-gray-400'} ${day === 4 ? 'ring-2 ring-orange-300' : ''}`} data-id="element-252">
                  {day}
                </div>)}
            </div>
            <div className="mb-4" data-id="element-253">
              <h4 className="font-medium text-gray-800 mb-2" data-id="element-254">
                Heute: 30 Sekunden kalte Dusche
              </h4>
              <p className="text-sm text-gray-600 mb-3" data-id="element-255">
                Erhöhe die Zeit unter kaltem Wasser auf mindestens 30 Sekunden.
                Atme tief und kontrolliert.
              </p>
              <button className="bg-orange-600 text-white px-4 py-2 rounded-lg text-sm font-medium w-full" data-id="element-256">
                Challenge für heute abschließen
              </button>
            </div>
            <div className="border-t border-gray-100 pt-3" data-id="element-257">
              <div className="flex items-center justify-between" data-id="element-258">
                <div className="flex items-center" data-id="element-259">
                  <UsersIcon size={18} className="text-gray-500 mr-2" data-id="element-260" />
                  <span className="text-sm text-gray-600" data-id="element-261">28 Teilnehmer</span>
                </div>
                <button className="text-purple-600 text-sm font-medium" data-id="element-262">
                  Rangliste ansehen
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Challenge Benefits */}
      <section className="mb-8" data-id="element-263">
        <h2 className="text-lg font-semibold text-gray-800 mb-4" data-id="element-264">
          Vorteile deiner aktuellen Challenge
        </h2>
        <div className="bg-white rounded-xl shadow-sm p-4 space-y-3" data-id="element-265">
          <div className="flex items-center" data-id="element-266">
            <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center mr-3" data-id="element-267">
              <span className="text-orange-600 font-medium" data-id="element-268">1</span>
            </div>
            <p className="text-gray-700" data-id="element-269">
              Verbesserte Durchblutung und Immunfunktion
            </p>
          </div>
          <div className="flex items-center" data-id="element-270">
            <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center mr-3" data-id="element-271">
              <span className="text-orange-600 font-medium" data-id="element-272">2</span>
            </div>
            <p className="text-gray-700" data-id="element-273">
              Erhöhte Produktion von braunem Fettgewebe
            </p>
          </div>
          <div className="flex items-center" data-id="element-274">
            <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center mr-3" data-id="element-275">
              <span className="text-orange-600 font-medium" data-id="element-276">3</span>
            </div>
            <p className="text-gray-700" data-id="element-277">
              Reduziertes Stressniveau durch Noradrenalin-Ausschüttung
            </p>
          </div>
          <div className="flex items-center" data-id="element-278">
            <div className="w-8 h-8 rounded-full bg-orange-100 flex items-center justify-center mr-3" data-id="element-279">
              <span className="text-orange-600 font-medium" data-id="element-280">4</span>
            </div>
            <p className="text-gray-700" data-id="element-281">
              Gestärkte mentale Widerstandsfähigkeit
            </p>
          </div>
        </div>
      </section>
      {/* Available Challenges */}
      <section data-id="element-282">
        <div className="flex justify-between items-center mb-4" data-id="element-283">
          <h2 className="text-lg font-semibold text-gray-800" data-id="element-284">
            Verfügbare Challenges
          </h2>
          <button className="text-purple-600 flex items-center text-sm font-medium" data-id="element-285">
            Alle anzeigen <ArrowRightIcon size={16} className="ml-1" data-id="element-286" />
          </button>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-287">
          <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-288">
            <div className="h-24 bg-blue-200 relative" data-id="element-289">
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-290">
                <h3 className="font-bold text-gray-800" data-id="element-291">
                  21-Tage Besser Schlafen
                </h3>
              </div>
            </div>
            <div className="p-4" data-id="element-292">
              <p className="text-sm text-gray-600 mb-3" data-id="element-293">
                Verbessere deine Schlafqualität mit bewährten Techniken und
                Routinen.
              </p>
              <div className="flex items-center justify-between" data-id="element-294">
                <div className="flex items-center" data-id="element-295">
                  <UserIcon size={16} className="text-gray-500 mr-1" data-id="element-296" />
                  <span className="text-xs text-gray-500" data-id="element-297">142 Teilnehmer</span>
                </div>
                <button className="bg-blue-600 text-white px-3 py-1 rounded-lg text-sm font-medium" data-id="element-298">
                  Starten
                </button>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-299">
            <div className="h-24 bg-green-200 relative" data-id="element-300">
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-301">
                <h3 className="font-bold text-gray-800" data-id="element-302">30-Tage Zuckerfrei</h3>
              </div>
            </div>
            <div className="p-4" data-id="element-303">
              <p className="text-sm text-gray-600 mb-3" data-id="element-304">
                Befreie dich von Zuckerabhängigkeit und verbessere deinen
                Stoffwechsel.
              </p>
              <div className="flex items-center justify-between" data-id="element-305">
                <div className="flex items-center" data-id="element-306">
                  <UserIcon size={16} className="text-gray-500 mr-1" data-id="element-307" />
                  <span className="text-xs text-gray-500" data-id="element-308">98 Teilnehmer</span>
                </div>
                <button className="bg-green-600 text-white px-3 py-1 rounded-lg text-sm font-medium" data-id="element-309">
                  Starten
                </button>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-310">
            <div className="h-24 bg-purple-200 relative" data-id="element-311">
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-312">
                <h3 className="font-bold text-gray-800" data-id="element-313">14-Tage Meditation</h3>
              </div>
            </div>
            <div className="p-4" data-id="element-314">
              <p className="text-sm text-gray-600 mb-3" data-id="element-315">
                Reduziere Stress und verbessere deine mentale Klarheit.
              </p>
              <div className="flex items-center justify-between" data-id="element-316">
                <div className="flex items-center" data-id="element-317">
                  <UserIcon size={16} className="text-gray-500 mr-1" data-id="element-318" />
                  <span className="text-xs text-gray-500" data-id="element-319">205 Teilnehmer</span>
                </div>
                <button className="bg-purple-600 text-white px-3 py-1 rounded-lg text-sm font-medium" data-id="element-320">
                  Starten
                </button>
              </div>
            </div>
          </div>
          <div className="bg-white rounded-xl shadow-sm overflow-hidden" data-id="element-321">
            <div className="h-24 bg-red-200 relative" data-id="element-322">
              <div className="absolute inset-0 flex items-center justify-center" data-id="element-323">
                <h3 className="font-bold text-gray-800" data-id="element-324">
                  7-Tage Bewegungschallenge
                </h3>
              </div>
            </div>
            <div className="p-4" data-id="element-325">
              <p className="text-sm text-gray-600 mb-3" data-id="element-326">
                Integriere täglich kurze, effektive Bewegungseinheiten in deinen
                Alltag.
              </p>
              <div className="flex items-center justify-between" data-id="element-327">
                <div className="flex items-center" data-id="element-328">
                  <UserIcon size={16} className="text-gray-500 mr-1" data-id="element-329" />
                  <span className="text-xs text-gray-500" data-id="element-330">176 Teilnehmer</span>
                </div>
                <button className="bg-red-600 text-white px-3 py-1 rounded-lg text-sm font-medium" data-id="element-331">
                  Starten
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>;
};